import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { Alignment, Icon, TextArea, TextInput } from 'tacho-ui';

import { ApplicationState } from '../../../state/ApplicationState';
import { DispatchType } from '../../../state/configureStore';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
import { Distributor } from '../../../core/domainModels/distributors/Distributor';
import { UpdateDistributor, defaultUpdateDistributor } from '../../../core/domainModels/distributors/UpdateDistributor';
import { fetchDistributorsThunk, updateDistributorThunk } from '../../../state/distributors/reducer';
interface UpdateDistributorModalProps {
    isOpen: boolean;
    distributor: Distributor;
    onToggle: () => void;
}
export const UpdateDistributorModal = (props: UpdateDistributorModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [distributorData, setDistributorData] = useState<UpdateDistributor>(defaultUpdateDistributor);
    const onSubmit = () => {
        dispatch(updateDistributorThunk(distributorData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchDistributorsThunk());
                    setDistributorData(defaultUpdateDistributor);
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const updateDistributorPending = useSelector((state: ApplicationState) => state.distributors.updateDistributorPending);
    const updateDistributorError = useSelector((state: ApplicationState) => state.distributors.updateDistributorError);

    useEffect(() => {
        if (props.distributor) {
            setDistributorData({ ...props.distributor, distributorId: props.distributor.id });
        }
    }, [props.isOpen]);
    return (
        <TachoModal
            size={'lg'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setDistributorData(defaultUpdateDistributor);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="distributorUpdate" icon={Icon.User} />}
            submitLabelToTranslate="commonUpdate"
            submitIcon={Icon.Edit}
            isPending={updateDistributorPending}
            errorToTranslate={updateDistributorError}
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'distributorName' })}
                            value={distributorData?.name}
                            onChange={value => setDistributorData({ ...distributorData, name: value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <TextArea
                        labelLength={-1}
                        label={formatMessage({ id: 'distributorNotes' })}
                        align={Alignment.flexStart}
                        value={distributorData.notes}
                        onChange={value => setDistributorData({ ...distributorData, notes: value as string })}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
